import React, { useRef, Fragment, useState, useEffect } from 'react';

import { Link } from 'gatsby';
import * as typeformEmbed from '@typeform/embed';

import { SiGraphql } from 'react-icons/si';
import { FiBook } from 'react-icons/fi';

const Header = () => {
  useEffect(() => {
    const typeform = typeformEmbed.makePopup('https://form.typeform.com/to/O93dOf8h', {
      mode: 'drawer_right',
    });
    document.getElementById('typeform-link').addEventListener('click', e => {
      e.preventDefault();
      typeform.open();
    });
  }, []);

  return (
    <Fragment>
      <header className="header">
        <Link to="/" className="logo">
          <SiGraphql className="icon" />
          <h4 className="title">GraphQL Tools</h4>
        </Link>
        <p>Discover new apps and connect your existing tools with GraphQL.</p>
        <a id="typeform-link" className="link" href="/">
          <FiBook className="icon" />
          Submit a tool
        </a>
      </header>
    </Fragment>
  );
};

export default Header;
